import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-16a3afcd"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "waring"
}, "!", -1));
export default /*#__PURE__*/_defineComponent({
  __name: 'warningToolTips',
  emits: ['onResendSmS'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const handleResendSmS = () => {
      emits('onResendSmS');
    };
    return (_ctx, _cache) => {
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      return _openBlock(), _createBlock(_component_el_tooltip, {
        placement: "right",
        "popper-class": "waring-tooltips"
      }, {
        content: _withCtx(() => [_createElementVNode("a", {
          class: "cp",
          onClick: handleResendSmS
        }, "重新发送验证短信")]),
        default: _withCtx(() => [_hoisted_1]),
        _: 1
      });
    };
  }
});